<template>
    <div>

        <b-modal id="create-or-update-military" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-military-create-or-update v-model="military" :errors="errors"></employee-military-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
        
        <v-table    ref="table"
                    search
                    up-class="px-1 pb-1"
                    with-items
                    :items="value"
                    name="employee-military"
                    :add-callback="createNew"
                    :buttons="buttons"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeMilitaryCreateOrUpdate from './EmployeeMilitaryCreateOrUpdate.vue'
import randomatic from 'randomatic'
import moment from 'moment'

export default {
    components:{
        EmployeeMilitaryCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Rütbe",key:"MilitaryTitleName",thClass:"w-50"},
                {name:"Başlangıç Tarihi",key:"StartDateVisual",thClass:"w-25"},
                {name:"Bitiş Tarihi",key:"EndDateVisual",thClass:"w-25"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            military:{
                Id:null,
                MilitaryTitleId:null,
                MilitaryTitleName:null,
                StartDate:null,
                StartDateVisual:null,
                EndDate:null,
                EndDateVisual:null
            },
            errors:{},
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.military.Id = null
            this.military.MilitaryTitleId = null
            this.military.MilitaryTitleName = null
            this.military.StartDate = null
            this.military.StartDateVisual = null
            this.military.EndDate = null
            this.military.EndDateVisual = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-military')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.military.Id = item.Id
            this.military.MilitaryTitleId = item.MilitaryTitleId
            this.military.MilitaryTitleName = item.MilitaryTitleName
            this.military.StartDate = item.StartDate
            this.military.StartDateVisual = item.StartDateVisual
            this.military.EndDate = item.EndDate
            this.military.EndDateVisual = item.EndDateVisual
            this.$showModal('create-or-update-military')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.military.MilitaryTitleId)){
                this.$set(this.errors,'MilitaryTitleId','Rütbe alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.military.StartDate)){
                this.$set(this.errors,'StartDate','Başlangış tarihi alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.military.EndDate)){
                this.$set(this.errors,'EndDate','Bitiş tarihi alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                if(this.military.Id){
                    let item = this.value.find(r=> r.Id == this.military.Id)
                    this.$set(item,"MilitaryTitleId",this.military.MilitaryTitleId)
                    this.$set(item,"MilitaryTitleName",this.military.MilitaryTitleName)
                    this.$set(item,"StartDate",this.military.StartDate)
                    this.$set(item,"StartDateVisual",moment(this.military.StartDate).locale("tr").format('L'))
                    this.$set(item,"EndDate",this.military.EndDate)
                    this.$set(item,"EndDateVisual",moment(this.military.EndDate).locale("tr").format('L'))
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:randomatic("A0",10),
                        MilitaryTitleId:this.military.MilitaryTitleId,
                        MilitaryTitleName:this.military.MilitaryTitleName,
                        StartDate:this.military.StartDate,
                        StartDateVisual:moment(this.military.StartDate).locale("tr").format('L'),
                        EndDate:this.military.EndDate,
                        EndDateVisual:moment(this.military.EndDate).locale("tr").format('L'),
                        Unsaved:true
                    })
                }
                this.$hideModal('create-or-update-military')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem askerlik bilgisini silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>